<template>
    <div class="split-pages-container">
        <ol class="split-pages">
            <li @click="jumpToPage(item)" :class="{'split-page': true, 'current': item.checked, 'more': item.isMore}" v-for="item in listPage" :key="item.id">{{item.isMore ? '...' : item.pageNo}}</li>
        </ol>
        <div :class="{'btn-page-prev': true, 'disable': disablePrev}" @click="toPrev">上一頁</div>
        <div :class="{'btn-page-next': true, 'disable': disableNext}" @click="toNext">下一頁</div>
    </div>
</template>

<script>
    import { v4 as uuidv4 } from 'uuid'
    //表示前后都有省略号时中间页面刷新基准，为了防止点击中间时页面频繁刷新页面导致的视觉错位
    var tmpPageIndex = 0;
	export default {
        props: {
            initData: Object,
            onPageChanged: Function,
        },
        data: function(){
            return {
                totalPage: 0,
                pageSize: 10,
                disablePrev: true,
                disableNext: true,
                listPage: [
                    {
                        pageNo: 1,
                        checked: true,
                    }
                ],
            }
        },
        mounted: function(){
            this.pageSize = this.initData.pageSize
            this.totalPage = Math.floor((this.initData.total + this.pageSize - 1)/this.pageSize)
            var pageNo = this.initData.pageNo
            
            this.refreshPageInfo(pageNo)

            var hash = this.$route.hash
            hash = hash.replace('#', '')
            var list = hash.split('&')
            var key = list[0].split('=')[0]
            var value = list[0].split('=')[1] / 1
            var pageNo = 1
            if(key == 'page') {
                if(! isNaN(value)) {
                    pageNo = parseInt(value) < 1 ? 1 : parseInt(value)
                }
            }
            if(pageNo >= this.totalPage) {
                this.disableNext = true
                this.disablePrev = pageNo==1
            } else if(pageNo == 1) {
                this.disablePrev = true
                this.disableNext = false
            } else {
                this.disablePrev = false
                this.disableNext = false
            }
        },
        methods: {
            // 刷新|生成分页信息|自定义属性page表示当前页面索引
            refreshPageInfo: function(pageNo) {
                // 总页数小于等于10页，全部显示
                if (this.totalPage <= 7) {
                    var list = []
                    for(var i=1; i<=this.totalPage; i++) {
                        list.push({
                            id: uuidv4(), 
                            pageNo: i,
                            isMore: false,
                            checked: pageNo == i
                        })
                    }
                    this.listPage = list
                    // 当前页是前10页
                } else if (pageNo < 7) {
                    var list = []
                    for(var i=1; i<=7; i++) {
                        list.push({
                            id: uuidv4(), 
                            pageNo: i,
                            isMore: false,
                            checked: pageNo == i
                        })
                    }
                    list.push({
                        id: uuidv4(), 
                        pageNo: null,
                        isMore: true,
                        checked: false
                    })
                    list.push({
                        id: uuidv4(), 
                        pageNo: this.totalPage,
                        isMore: false,
                        checked: false
                    })
                    this.listPage = list
                    // 当前页面是最后10页
                } else if (this.totalPage - pageNo < 7) {
                    var list = []
                    if (this.totalPage - 7 > 1) {
                        list.push({
                            id: uuidv4(), 
                            pageNo: 1,
                            isMore: false,
                            checked: false
                        })
                        list.push({
                            id: uuidv4(),
                            pageNo: null,
                            isMore: true,
                            checked: false
                        })
                    }
                    
                    if(pageNo >= this.totalPage - 4 && pageNo<= this.totalPage) {
                        for (var i = this.totalPage - 4; i <= this.totalPage; i++) {
                            list.push({
                                id: uuidv4(),
                                pageNo: i,
                                isMore: false,
                                checked: pageNo == i
                            })

                            if (i == 1) {
                                list.push({
                                    id: uuidv4(),
                                    pageNo: null,
                                    isMore: true,
                                    checked: false
                                })
                            }
                        }
                    } else {
                        for (var i = pageNo/1 - 2; i <= pageNo/1+2; i++) {
                            list.push({
                                id: uuidv4(),
                                pageNo: i,
                                isMore: false,
                                checked: pageNo/1 == i
                            })
                        }
                        
                        list.push({
                            id: uuidv4(),
                            pageNo: null,
                            isMore: true,
                            checked: false
                        })
                        list.push({
                            id: uuidv4(), 
                            pageNo: this.totalPage,
                            isMore: false,
                            checked: false
                        })
                    }
                    this.listPage = list
                } else {
                    var list = []
                    // 当前页面基于所有页面中间位置
                    // 初始化页面基准坐标
                    if (tmpPageIndex == 0) {
                        tmpPageIndex = pageNo
                    }
                    // 当页面索引达到最前或最后时，需要重新设置页面基准坐标
                    if (tmpPageIndex <= pageNo - 5 || tmpPageIndex >= pageNo + 5) {
                        tmpPageIndex = pageNo
                    }
                    list.push({
                        id: uuidv4(), 
                        pageNo: 1,
                        isMore: false,
                        checked: false
                    })
                    list.push({
                        id: uuidv4(),
                        pageNo: null,
                        isMore: true,
                        checked: false
                    })
                    for (var i = tmpPageIndex - 2; i <= tmpPageIndex + 2; i++) {
                        list.push({
                            id: uuidv4(), 
                            pageNo: i,
                            isMore: false,
                            checked: pageNo == i
                        })
                    }
                    list.push({
                        id: uuidv4(),
                        pageNo: null,
                        isMore: true,
                        checked: false
                    })
                    list.push({
                        id: uuidv4(),
                        pageNo: this.totalPage,
                        isMore: false,
                        checked: false
                    })
                    this.listPage = list
                }
            },
            toPrev: function(){
                var mPage = this.listPage.find((p)=>p.checked)
                if(mPage.pageNo > 1) {
                    this.jumpToPage(this.listPage.find((p)=>p.pageNo==mPage.pageNo-1), false)
                }
            },
            toNext: function(){
                var mPage = this.listPage.find((p)=>p.checked)
                if(mPage && mPage != this.listPage[this.listPage.length - 1]) {
                    this.jumpToPage(this.listPage.find((p)=>p.pageNo==mPage.pageNo+1), true)
                }
            },
            jumpToPage: function(page, toNext) {
                if(!page) {
                    var mPage = this.listPage.find((p)=>p.checked)
                    tmpPageIndex = 0
                    this.refreshPageInfo(toNext ? mPage.pageNo+1 : mPage.pageNo-1)
                    this.onPageChanged && this.onPageChanged(toNext ? mPage.pageNo+1 : mPage.pageNo-1)
                    return
                }
                if(page.isMore) {
                    var mPage = this.listPage.find((p)=>p.checked)
                    if(mPage.pageNo < this.totalPage) {
                        var tmpPage = this.listPage.find((p)=>!p.isMore && mPage.pageNo+1== p.pageNo)
                        if(tmpPage) {
                            tmpPageIndex = 0
                            this.refreshPageInfo(tmpPage.pageNo)
                            this.onPageChanged && this.onPageChanged(tmpPage.pageNo)
                        }
                    }
                } else {
                    this.refreshPageInfo(page.pageNo)
                    this.onPageChanged && this.onPageChanged(page.pageNo)
                }
            },
            changePage: function(pageNo){
                var list = []
                if(this.totalPage <= 7) {
                    for(var i=1; i<=this.totalPage && i<=7; i++) {
                        list[i-1] = {
                            id: uuidv4(), 
                            pageNo: i,
                            isMore: false,
                            checked: pageNo == i
                        }
                    }
                } else {
                    var end = pageNo + 3
                    if(end > this.totalPage) {
                        end = this.totalPage
                    }
                    var start = (end - 7) < 0 ? 0 : (end - 7)
                    var moreIndex = end - 2
                    if(pageNo >= moreIndex) {
                        moreIndex = start+1
                    } else {
                        moreIndex = start + 2
                        if(pageNo <= moreIndex) {
                            moreIndex  = end - 1
                        }
                    }
                    for(var i=1; i<=7; i++) {
                        list[i-1] = {
                            id: uuidv4(), 
                            pageNo: i+start,
                            isMore: moreIndex == i,
                            checked: pageNo == i
                        }
                    }
                }
                this.listPage = list
            }
        },
        watch: {
            $route: function(to, from){
                var hash = this.$route.hash
                hash = hash.replace('#', '')
                var list = hash.split('&')
                var key = list[0].split('=')[0]
                var value = list[0].split('=')[1] / 1
                var pageNo = 1
                if(key == 'page') {
                    if(! isNaN(value)) {
                        pageNo = parseInt(value) < 1 ? 1 : parseInt(value)
                    }
                }
                if(pageNo >= this.totalPage) {
                    this.disableNext = true
                    this.disablePrev = pageNo==1
                } else if(pageNo == 1) {
                    this.disablePrev = true
                    this.disableNext = false
                } else {
                    this.disablePrev = false
                    this.disableNext = false
                }
            }
        }
    }
</script>

<style scoped>
	.split-pages-container {
		position: absolute;
		bottom: 20px;
		right: 20px;
		display: flex;
		flex-direction: row;
		margin-top: 25px;
		justify-content: flex-end;
	}

	.split-pages-container > .split-pages {
		display: flex;
		flex-direction: row;
	}

	.split-pages-container > .split-pages > .split-page {
		display: inline-block;
		padding: 0px 10px;
        min-width: 30px;
		height: 22px;
		border-radius: 4px;
		color: #969696;
		font-size: 14px;
		line-height: 22px;
		text-align: center;
		font-weight: 400;
		margin-right: 20px;
		background-color: #DDDDDD;
		cursor: pointer;
	}

	.split-pages-container > .split-pages > .split-page.more {
		line-height: 16px;
	}

	.split-pages-container > .split-pages > .split-page:hover,
	.split-pages-container > .split-pages > .split-page.current {
		color: #fff;
		background-color: #36C4D0;
		font-weight: bold;
	}

	.split-pages-container > .btn-page-prev,
	.split-pages-container > .btn-page-next {
		height: 20px;
		width: 56px;
		text-align: center;
		line-height: 20px;
		font-weight: 300;
		color: #231F20;
		background-color: #DDDDDD;
		border-radius: 4px;
		font-weight: 400;
		font-size: 14px;
		cursor: pointer;
	}

    .split-pages-container > .btn-page-prev {
        margin-right: 9px;
    }

    .split-pages-container > .btn-page-prev.disable,
	.split-pages-container > .btn-page-next.disable {
		color: #636363;
	}
</style>
